import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { Role, UserOnboardingStatus, VerificationStatus } from '@logistics-platform/types';

export interface UserState {
  id: string;
  email: string;
  role: Role;
  onboardingStatus: UserOnboardingStatus;
  verificationStatus: VerificationStatus;
  profile?: {
    fullName: string;
  };
}

interface AuthState {
  user: UserState | null;
  token: string | null;
  trackingJobId: string | null;
  setUser: (user: UserState | null) => void;
  setToken: (token: string | null) => void;
  setTrackingJobId: (jobId: string | null) => void;
  login: (data: { user: UserState; token: string }) => void;
  logout: () => void;
  setVerified: () => void;
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      user: null,
      token: null,
      trackingJobId: null,
      setUser: (user) => set({ user }),
      setToken: (token) => set({ token }),
      setTrackingJobId: (jobId) => set({ trackingJobId: jobId }),
      login: (data) => set({ user: data.user, token: data.token }),
      setVerified: () =>
        set((state) => ({
          user: state.user ? {
            ...state.user,
            onboardingStatus: UserOnboardingStatus.verified,
            verificationStatus: VerificationStatus.VERIFIED
          } : null,
        })),
      logout: () => {
        set({ user: null, token: null, trackingJobId: null });
      },
    }),
    {
      name: 'auth-storage',
      partialize: (state) => ({ user: state.user, token: state.token, trackingJobId: state.trackingJobId }),
    }
  )
);
